// extracted by mini-css-extract-plugin
module.exports = {"container":"DialogTitle_container__fzKcp","header":"DialogTitle_header__LWcFY","title":"DialogTitle_title__1ew_b"};